import React from 'react';
import { getTrackColorByStateAndDifficulty } from "../../helpers/map";
import { tracksWidth, arrowWidth } from "../../config/defaults";
import { TRACK_DIFFICULTY_BLUE } from "../../config/constants";

const Connector8BRed8DBlue8CRed = ({ state, workState }) => (
	<g id="Track-8D-blue-connector" transform="translate(1904.000000, 611.000000)">
		<g transform="translate(0.000000, 0.609312)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			 strokeLinecap="round"
		>
			<path d="M229,199.890688 L242,224.820731 M242,224.820731 L256,252"
						strokeWidth={tracksWidth}/>
		</g>
	</g>
);

export default Connector8BRed8DBlue8CRed;
